import React, { useState, useEffect } from 'react';
import { useExperiment } from '../../contexts/ExperimentContext';

const Header: React.FC = () => {
  const { participant } = useExperiment();
  const [timeRemaining, setTimeRemaining] = useState<number | null>(null);

  useEffect(() => {
    if (participant?.conditions?.timePressure === 'high' && participant?.phase === 'email-task') {
      // 2 minute timer for high time pressure condition
      setTimeRemaining(120);
      
      const timer = setInterval(() => {
        setTimeRemaining(prev => {
          if (prev === null || prev <= 0) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    } else {
      setTimeRemaining(null);
    }
  }, [participant?.conditions?.timePressure, participant?.phase]);

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return null;
};

export default Header;